export default __webpack_public_path__ + "static/media/clientes8.1efec377.png";